import React from "react";
import { Link } from "react-router-dom";
import { GiClick } from "react-icons/gi";
import { courseDetails } from "../../constants";

const Courses = () => {
  return (
    <div className="w-full mx-auto">
      <div className="max-w-screen-2xl bg-white py-20 mx-auto flex flex-col gap-10 borer-b-[1px] border-b border-b-primeColor">
        <div className="flex flex-col justify-center gap-2 items-center">
          <h1 className="text-6xl font-titleFont font-bold text-primeColor">
            Our Courses
          </h1>
          <span className="w-32 h-1 bg-primeColor inline-block"></span>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-center xl:grid-cols-4 gap-2 relative">
          {courseDetails.map((course) => (
            <div
              key={course.id}
              className="h-80 max-w-[310px] relative overflow-hidden mb-6 border-[1px] rounded-lg border-gray-300 hover:border-primeColor hover:border-opacity-75 transition-hover duration-300 group"
            >
              <Link to={course.link}>
                <img
                  className="w-full h-2/3 object-fill rounded-t-lg duration-500"
                  src={course.Image}
                  alt="educareSpokenEnglish"
                />
                <div className="h-1/3 flex flex-col justify-center px-4">
                  <h4 className="font-bodyFont text-xl font-semibold">
                    {course.title}
                  </h4>
                  <p className="text-[16px] text-gray-600">{course.des}</p>
                </div>
                <div className="w-full h-2/3 absolute top-0 bg-gray-900 bg-opacity-60 -translate-x-[100%] group-hover:translate-x-[0] transition-transform duration-300"></div>
                <p className="absolute text-lg items-center top-[30%] gap-2 left-24 hidden group-hover:flex text-white font-titleFont font-semibold animate-bounce">
                  Learn More
                  <span>
                    <GiClick className="text-2xl text-green-100" />
                  </span>
                </p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;
